import { useRouteError } from "react-router-dom";
import { Alert } from "react-bootstrap";

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <div id="error-page" className="text-center">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <Alert className="w-50 mx-auto" variant={"warning"}>
        <i>{error.statusText || error.message}</i>
      </Alert>
    </div>
  );
}
